import { Box, Text, chakra, Flex, FormControl, Switch, Button, Link as ChakraLink } from "@chakra-ui/react";
import moment from "moment";
import { formatNumber } from '../../utils/helper';
import SpeedometerChart from '../charts/SpeedometerChart';

import AverageDailyIncrease from "./AverageDailyIncrease";
import { useState } from "react";
import { Link, Link as RouterLink } from 'react-router-dom';
import AddressMarksByProjectChart from "../charts/AddressMarksByProjectChart";
import MarksDailyChart from "./MarksDailyChart";
import BlurChartWrapper from "./BlurChartWrapper";
import { FaTwitter } from "react-icons/fa";

// Helper function to filter data based on the selected period
const filterData = (data, filter) => {
	const now = new Date();
	const oneWeekAgo = new Date(now.setDate(now.getDate() - 7));
	return filter === 'lastWeek'
		? data.filter(point => new Date(point.date) >= oneWeekAgo)
		: data;
};

const RankCard = ({ rankData, isKeyMintAvailiable, chartData, onMintModalOpen, isUserHasKey, twitterLink }) => {
	const resultColor = rankData.percentage < 2 ? "#FF684B" : 'red';
	const [filter, setFilter] = useState('lastWeek'); // Default filter
	// Filter the chart data based on the selected filter
	const filteredChartData = filterData(chartData, filter);
	const [isDailyGraph, setIsDailyGraph] = useState(true);

	const twitterText = rankData && encodeURIComponent(`My Scroll Marks Rank is ${formatNumber(rankData.rank)}. Find out where you stand (by @scrollstat) https://scrollstat.xyz/check-marks-rank`);

	const handleSwitchChange = () => {
		setIsDailyGraph(!isDailyGraph);
	}

	return (
		<Flex
			flexWrap={{ base: "wrap", md: "nowrap" }} // Stack blocks vertically on mobile
			flexDirection={{ base: "column", md: "row" }} // Adjust direction based on screen size
			gap={2}
			pt={4}
		>
			{/* Первый блок */}
			<Flex flexFlow="column" gap={2} minWidth={{ base: "100%", md: "300px", lg: "450px" }} maxWidth="450px">
				<Box
					p={8}
					borderWidth={0}
					borderRadius="lg"
					textAlign="center"
					backgroundColor="#FEF0DD"
					width="100%"
					mx="auto"
					borderColor={resultColor}
				>
					<Box width="auto" height={{ base: "80px", md: "120px" }} backgroundColor="#FEF0DD" borderRadius="lg">
						<Text fontSize={{ base: "5xl", md: "6xl" }} fontWeight="bold" color="#FF684B">
							#{formatNumber(rankData.rank)}
						</Text>
					</Box>

					<Text color="gray.700">
						Your wallet <chakra.span fontWeight="bold">{rankData.address.slice(0, 5)}...{rankData.address.slice(-2)}</chakra.span> is in <chakra.span color="#FF5733" fontWeight="bold">Top {Math.ceil(rankData.percentage)}%</chakra.span> and better than {formatNumber(rankData.totalUsers - rankData.rank)} of {formatNumber(rankData.totalUsers)} users.
					</Text>

					<SpeedometerChart percentage={rankData.percentage} />

					<Text fontSize="md" color="gray.600" pt={1.5} pb={2}>
						Rank updated {moment(rankData.timestamp).format('DD MMM YYYY')}
					</Text>
					<ChakraLink isExternal href={twitterLink + twitterText} variant={"outline"} colorScheme="twitter" opacity={0.75} style={{ textDecoration: 'none' }} >
						<Button as="div" variant="outline" colorScheme="twitter" rightIcon={<FaTwitter />} size={'sm'}>Share on Twitter</Button>
					</ChakraLink>
				</Box>
			</Flex>

			{/* Второй блок */}
			<Flex flexFlow="column" minWidth={{ base: "100%", md: "300px", lg: "450px" }} maxWidth="450px" gap={2}>
				<Flex flexFlow="row" gap={2} justifyContent="space-between" flexWrap="wrap">
					<Box
						width={{ base: "100%", md: "48%", lg: '49.1%' }} // Full width on mobile, half width on larger screens
						height="120px"
						backgroundColor="#FEF0DD"
						borderRadius="lg"
					// border={"1px solid"}
					// borderColor={"green"}
					>
						<Box pt={6} pb={2}>
							<Text fontSize="16px">Total Marks</Text>
						</Box>
						<chakra.span color="#FF684B" fontWeight="bold" fontSize="24px">{formatNumber(parseFloat(rankData.points).toFixed(2))}</chakra.span>
					</Box>

					<Box
						width={{ base: "100%", md: "48%", lg: '49.1%' }} // Full width on mobile, half width on larger screens
						height="120px"
						backgroundColor="#FEF0DD"
						borderRadius="lg"
					>
						<Box pt={6} pb={2}>
							<Text fontSize="16px">Average Daily Increase</Text>
						</Box>
						{isUserHasKey ? <AverageDailyIncrease data={filteredChartData} /> :
							<chakra.span filter="blur(5px)" fontSize="26px" pt={2}>N!N</chakra.span>
						}
					</Box>
				</Flex>

				<Box backgroundColor="#FEF0DD" borderRadius="lg" pb={4} width="100%" p={4} >
					<FormControl display="flex" alignItems="center" justifyContent="center" pt={2} pb={2}>
						<Text mr={2}>Marks Daily Chart</Text>
						<Box>
							<Switch id="mode-switch" isChecked={!isDailyGraph} onChange={handleSwitchChange}
								size={"sm"}
								colorScheme="orange"
								sx={{
									'& .chakra-switch__track': {
										backgroundColor: 'orange.500' // Always orange
									},
									'&.chakra-switch--checked .chakra-switch__track': {
										backgroundColor: 'orange.500' // Checked state
									}
								}}
							/>
						</Box>
						<Text ml={2}>Marks By Projects</Text>
					</FormControl>

					{/* <Text pt={isUserHasKey ? 3 : 5} pb={1} fontSize="20px">Marks Daily Chart</Text> */}

					{isKeyMintAvailiable && chartData && chartData.length > 0 ? (
						<Flex
							w="100%"
							mt={2}
							mb={6}
							justifyContent="center"
							alignItems="center"
							direction="column"
						>
							<Box
								w={{ base: '90%', md: '75%' }}
								maxW="700px"
								h="auto"
								m={1}
								borderRadius="md"
								borderColor={"#FF684B"}
							>
								{!isUserHasKey ?
									<BlurChartWrapper data={rankData.graphData} onMintModalOpen={onMintModalOpen} />
									:
									<>
										{isDailyGraph ?
											<MarksDailyChart
												isKeyMintAvailiable={isKeyMintAvailiable}
												chartData={chartData}
												isUserHasKey={isUserHasKey}
												rankData={rankData}
												onMintModalOpen={onMintModalOpen}
												setFilter={setFilter}
												filter={filter}
												filteredChartData={filteredChartData}
											/>
											:
											<AddressMarksByProjectChart holding={rankData.holding} farming={rankData.farming} />
										}
									</>
								}
							</Box>
						</Flex>
					)
						:
						<Text color={"gray.700"} pb={4}> There is not enough data to display the graphic. Please try again later.</Text>
					}

					{(isDailyGraph || !isUserHasKey) && <Text align="center" pb={4} pt={5} mb={isUserHasKey ? 0 : '3px'}>
						Want more marks?{' '}
						<Link as={RouterLink} to="/scroll-marks-calculator">
							<chakra.span color="#FF5733" _hover={{ textDecoration: "underline" }} >
								Try our Marks Calculator
							</chakra.span>
						</Link>
					</Text>
					}
				</Box>
			</Flex>
		</Flex>
	);
};

export default RankCard;
